import * as angular from 'angular';
import * as _ from "lodash";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NewGuidServiceName, { NewGuidService } from "../../services/utility/newguid.service";
import TiamaDefectMappingServiceName, { TiamaDefectMappingService } from "../../services/defects/tiamaDefectMapping.service";
import UIUtilityServiceName, { EnumOption, UIUtilityService } from "../../services/utility/uiUtility.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import DefectTypeServiceName, { DefectTypeService } from "../../services/defects/defectType.service";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import template from './addTiamaDefectMapping.tpl.html';
import { apsEnums } from '../../shared/dto/aps.enums';

let requires = [LoaderServiceName,
  UIUtilityServiceName,
  TiamaDefectMappingServiceName,
  NotifyServiceName,
  NewGuidServiceName,
  DefectTypeServiceName];

interface AddTiamaDefectMappingController {
  form: angular.IFormController;
  tiamaDefectMapping: apsViewModels.TiamaDefectMappingItem;
  defectTypes: apsViewModels.LookupItem[];
  machineTypes: EnumOption[];
  cancel(): void;
  submitTiamaDefectMapping(): void;
}

export function openAddTiamaDefectMapping($modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'AddTiamaDefectMappingCtrl as vm'
  }).result;
}

export default angular.module('aps.controller.addTiamaDefectMapping', requires)
  .controller('AddTiamaDefectMappingCtrl', addTiamaDefectMappingCtrl)
  .name;

function addTiamaDefectMappingCtrl(
  $modalInstance: mm.foundation.modalInstance,
  loaderService: LoaderService,
  newGuidService: NewGuidService,
  tiamaDefectMappingService: TiamaDefectMappingService,
  notifyService: NotifyService,
  defectTypeService: DefectTypeService
): AddTiamaDefectMappingController {

  let vm = this as AddTiamaDefectMappingController;

  vm.tiamaDefectMapping = {} as apsViewModels.TiamaDefectMappingItem;

  newGuidService.getNewGuid('tiamaDefectMapping').then(function (data) {
    vm.tiamaDefectMapping.id = data;
  });

  vm.machineTypes = [
    { value: apsEnums.EquipmentType.MX4, text: 'MX4' },
    { value: apsEnums.EquipmentType.Multi, text: 'MULTI' },
    { value: apsEnums.EquipmentType.Mcal, text: 'MCAL' }
  ];

  var promise1 = defectTypeService.getDefectTypesAll()
    .then(function (defectTypesAll) {
      vm.defectTypes = defectTypesAll;
    }, notifyService.handleApiErrors);
  loaderService.loadingPromise(promise1);

  var postTiamaDefectMapping = function () {
    var promise = tiamaDefectMappingService.addTiamaDefectMapping(vm.tiamaDefectMapping)
      .then(function () {
        vm.tiamaDefectMapping.defectTypeName = getDefectTypeName(vm.tiamaDefectMapping.defectTypeId);
        var data = {
          action: 'return',
          tiamaDefectMapping: vm.tiamaDefectMapping
        };
        $modalInstance.close(data);
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  var getDefectTypeName = function (defectId: string) {
    var defectType = _.find(vm.defectTypes,
      function (item: any) {
        return item.key === defectId;
      });

    if ((defectType || '') !== '') {
      return defectType.value;
    }
  };

  vm.submitTiamaDefectMapping = function () {
    if (vm.form.$invalid) {
      return;
    }
    postTiamaDefectMapping();
  };

  vm.cancel = function () {
    $modalInstance.close();
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/tiamaDefectMappings/addTiamaDefectMapping.controller.ts